export default {
  // Navbar
  'nav.home': 'Eksporta Pakalpojumi',
  'nav.choHem': 'Āzijas Tirgus',
  'nav.investment': 'Uzturēšanās Pakalpojumi',
  'nav.investment.main': 'Latvijas Uzturēšanās',
  'nav.investment.detail': 'Detalizēta Informācija',
  'nav.investment.partnership': 'Biznesa Sadarbība',
  'nav.investment.blog': 'Ziņas un Blogs',
  'nav.about': 'Par Mums',
  'nav.contact': 'Kontakti',
  'nav.consult': 'Konsultācija',

  // Footer
  'footer.about.title': 'Par The Daeg',
  'footer.about.desc': 'Mēs esam vadošais uzņēmums investīciju konsultāciju un Āzijas produktu izplatīšanas jomā Eiropā.',
  'footer.services.title': 'Pakalpojumi',
  'footer.services.investment': 'Latvijas Uzturēšanās Investīcijas',
  'footer.services.choHem': 'Āzijas Tirgus',
  'footer.services.export': 'Eksports uz Eiropu',
  'footer.services.partnership': 'Biznesa Sadarbība',
  'footer.contact.title': 'Kontakti',
  'footer.contact.address': 'Adrese',
  'footer.contact.addressValue': 'Rīga, Latvija',
  'footer.contact.phone': 'Tālrunis',
  'footer.contact.email': 'E-pasts',
  'footer.contact.hours': 'Darba laiks',
  'footer.contact.hoursValue': 'Pirmdiena - Piektdiena: 9:00 - 18:00',
  'footer.follow.title': 'Sekojiet Mums',
  'footer.copyright': '© 2025 The Daeg International. Visas tiesības aizsargātas.',

  // Consult Modal
  'consult.title': 'Bezmaksas Konsultācija',
  'consult.subtitle': 'Atstājiet savu informāciju, mūsu eksperti sazināsies ar jums 24 stundu laikā',
  'consult.form.name': 'Vārds un Uzvārds',
  'consult.form.namePlaceholder': 'Ievadiet savu vārdu',
  'consult.form.phone': 'Tālruņa Numurs',
  'consult.form.phonePlaceholder': 'Ievadiet tālruņa numuru',
  'consult.form.email': 'E-pasts',
  'consult.form.emailPlaceholder': 'Ievadiet savu e-pastu',
  'consult.form.service': 'Interesējošais Pakalpojums',
  'consult.form.servicePlaceholder': 'Izvēlieties pakalpojumu',
  'consult.form.serviceOptions.investment': 'Latvijas Uzturēšanās Investīcijas',
  'consult.form.serviceOptions.choHem': 'Āzijas Tirgus',
  'consult.form.serviceOptions.export': 'Eksports uz Eiropu',
  'consult.form.serviceOptions.partnership': 'Biznesa Sadarbība',
  'consult.form.message': 'Ziņojums',
  'consult.form.messagePlaceholder': 'Pastāstiet mums par savām vajadzībām...',
  'consult.form.submit': 'Nosūtīt Pieprasījumu',
  'consult.form.submitting': 'Nosūta...',
  'consult.success': 'Pieprasījums nosūtīts veiksmīgi! Mēs sazināsimies ar jums drīzumā.',
  'consult.error': 'Radās kļūda. Lūdzu, mēģiniet vēlreiz.',
};